import { Skeleton, Stack } from '@mui/material';
import { FormatPercent, Text } from '@vestwell-frontend/ui';

import { FC } from 'react';

type GridRowProps = {
  dateRangeName: string;
  dateRange: string;
  value?: number;
  loading?: boolean;
};

export const GridRow: FC<GridRowProps> = props => {
  return (
    <Stack
      alignItems='center'
      direction='row'
      justifyContent='space-between'
      spacing={2}>
      <Stack spacing={1}>
        <Text data-testid='rate-of-return-date-range' mb={0}>
          {props.loading ? <Skeleton width={140} /> : props.dateRangeName}
        </Text>
        <Text data-testid='rate-of-return-dates'>
          {props.loading ? <Skeleton width={165} /> : props.dateRange}
        </Text>
      </Stack>
      <Text data-testid='rate-of-return-value'>
        {props.loading ? (
          <Skeleton width={60} />
        ) : props.value ? (
          <FormatPercent value={props.value} />
        ) : (
          'Not available'
        )}
      </Text>
    </Stack>
  );
};
